module.exports = {
    drawChart: function(chartData) {
        var chart = AmCharts.makeChart("mediaReachBarChartdiv", {
          "type": "serial",
          // "dataDateFormat": "YYYYMMDD",
          "categoryField": "index",
          "marginBottom": 1,
          "marginLeft": 5,
          "marginRight": 5,
          "marginTop": 1,
          "sequencedAnimation": false,
          "startDuration": 0,
          // "startEffect": "easeOutSine",
          "categoryAxis": {
            "gridPosition": "start",
            // "parseDates": true
          },
          "trendLines": [],
          "graphs": [
            {
              "balloonText": "[[title]]:[[value]]",
              "fillAlphas": 0.9,
              "id": "AmGraph-1",
              "title": chartData[0].media1,
              "type": "column",
              "valueField": "media1Reach1",
              "lineColor": "#08a3cc"
            },
            {
              "balloonText": "[[title]]:[[value]]",
              "fillAlphas": 0.9,
              "id": "AmGraph-2",
              "title": chartData[0].media2,
              "type": "column",
              "valueField": "media2Reach1",
              "lineColor": "#F39C12"

            },
            {
              "balloonText": "[[title]]:[[value]]",
              "fillAlphas": 0.9,
              "id": "AmGraph-3",
              "title": chartData[0].media3,
              "type": "column",
              "valueField": "media3Reach1",
              "lineColor": "#3FC380"
            },
            {
              "balloonText": "[[title]]:[[value]]",
              "fillAlphas": 0.9,
              "id": "AmGraph-4",
              "title": chartData[0].media4,
              "type": "column",
              "valueField": "media4Reach1",
              "lineColor": "#3FC380"
            }
          ],
          "guides": [],
          "valueAxes": [
            {
              "id": "ValueAxis-1",
              "stackType": "regular",
              "minimum": 0,
              "gridAlpha": 0,
              "axisAlpha": 0,
              "labelsEnabled": false
            }
          ],
          "allLabels": [],
          "balloon": {},
          "chartCursor": {
              "zoomable": false,
              "enabled": true,
              "cursorAlpha": 0.3,
              "categoryBalloonColor": "#e26a6a",
              "categoryBalloonAlpha": 0.9
          },
          "legend": {
            "enabled": true,
            "position": "bottom",
            "equalWidths": false,
            "valueWidth": 0, // 50
            "useGraphSettings": true
          },
          "titles": [],
          "dataProvider": chartData,
          "colors": [
            "#20a8d8",
            "#ffc107",
            "#4dbd74",
            "#FCD202",
            "#F8FF01",
          ],
        });
    }
}



// WEBPACK FOOTER //
// ./src/views/budget/mediaReachResultBarChart.js